<template>
  <div class="lg:container 2xl:max-w-(--breakpoint-xl) mx-auto pb-10 lg:pb-0 px-0 lg:px-6 lg:mb-20 text-left relative h-full content-end">
    <div class="lg:grid lg:grid-cols-10 content-center gap-x-6 pt-8">
      <div class="container lg:col-span-4 xl:col-span-4 flex flex-col justify-center items-center gap-y-3 lg:gap-y-5 mx-auto px-6 lg:px-0 pb-6 lg:pb-40 relative">
        <UiHeadline design="h1" type="h1" class="font-bold leading-[1.22] w-full">
          <!-- eslint-disable vue/no-v-html -->
          <span v-html="props.headerDetails?.h1" />
        </UiHeadline>
        <div v-if="props.headerDetails?.subheadline" class="w-full text-base md:text-xl font-semibold">
          <!-- eslint-disable vue/no-v-html -->
          <span v-html="props.headerDetails?.subheadline" />
        </div>
        <div class="hidden lg:block absolute w-full bottom-0 left-0">
          <RuesTrust :trustpilot-box="headerDetails?.trustpilot_box" />
        </div>
      </div>
      <div class="lg:col-span-6 xl:col-span-6 absolute lg:relative top-0 left-0 w-full z-[-1] h-full">
        <img
          :src="props.headerDetails?.bild_url !== '' ? config.public.zoHostsImg + props.headerDetails?.bild_url : 'https://img.travanto.de/backgrounds/startseite/www.kiel-travel.de6168.jpeg'"
          :srcset="props.headerDetails?.srcset || undefined"
          sizes="(min-width: 1024px) 60vw, 100vw"
          alt="Portal"
          loading="eager"
          fetchpriority="high"
          width="350"
          height="370"
          class="object-center object-cover max-h-full lg:h-[421px] h-full w-full lg:rounded-2xl"
        >
        <div class="absolute lg:hidden top-0 lg:top-auto lg:bottom-0 w-full h-[310px] lg:h-[70%] opacity-80 bg-linear-to-b from-white" />
      </div>
    </div>

    <div class="container lg:absolute lg:left-0 lg:bottom-18 w-full mx-auto px-6 2xl:px-0">
      <div class="2xl:max-w-(--breakpoint-xl) 2xl:pl-6 lg:pr-4 mx-auto">
        <div class="border border-neutral-200 bg-white rounded-xl pt-0 lg:pt-2 pb-4 lg:pb-2 px-0 lg:px-2 w-full shadow-md">
          <RuesSearch :item="props.headerDetails?.search_element.data" design="ruesSearchbar" />
        </div>
      </div>
    </div>
  </div>
  <div class="container 2xl:max-w-(--breakpoint-xl) mx-auto lg:hidden grid grid-cols-12 gap-x-4 gap-y-8 px-6 mb-5 mt-8 lg:mt-12 text-left">
    <RuesTrust :trustpilot-box="headerDetails?.trustpilot_box" />
  </div>
</template>
<script setup lang="ts">
const props = defineProps({
  headerDetails: {
    type: Object,
    default: null
  }
})
const config = useRuntimeConfig()
const heroSizes = '(min-width: 1024px) 60vw, 100vw'

useHead(() => {
  const srcset = props.headerDetails?.srcset
  if (!srcset) {
    return {}
  }
  return {
    link: [{
      rel: 'preload',
      as: 'image',
      imageSrcset: srcset,
      imageSizes: heroSizes,
      fetchpriority: 'high'
    }]
  }
})
</script>
<style>
@reference "~/assets/css/main.css";
  .rues-header-for-rues-page-background {
    @apply h-auto lg:h-[370px] w-full;
  }
  .rues-headline-text-shadow {
    text-shadow: 0 2px 3px rgba(0,0,0,.18);
  }
</style>
